import { ComponentProps, InputHTMLAttributes } from 'react';

import { VStack } from '@ui-furniture/elements';
import {
  FormInput,
  FormInputComponent,
  useFieldRegistration,
} from '@ui-furniture/lib/form';
import { AddressTypeahead as SimpleAddressTypeahead } from '@ui-furniture/ui/inputs/address-typeahead';

import { useAddressFieldsRegistration } from './use-address-fields-registration';

import { ErrorMessage } from '../common';

export const AddressTypeahead: FormInputComponent<
  InputHTMLAttributes<any> &
    Omit<ComponentProps<typeof SimpleAddressTypeahead>, 'onSelect'>
> = ({ name, registerOptions, ...rest }) => {
  const { error } = useFieldRegistration(name);
  const { fields } = useAddressFieldsRegistration(name);

  return (
    <FormInput error={error?.message}>
      <VStack gap='xs'>
        <SimpleAddressTypeahead
          {...rest}
          onSelect={({ id, line1, line2, line3, city, postcode }) => {
            fields.id.setValue(id);
            fields.line1.setValue(line1);
            fields.line2.setValue(line2 || undefined);
            fields.line3.setValue(line3 || undefined);
            fields.city.setValue(city);
            fields.postcode.setValue(postcode);
          }}
        />
        <ErrorMessage />
      </VStack>
    </FormInput>
  );
};
